import {match, Pattern} from 'ts-pattern';

import {getFinancialProductOffer} from 'features/financial-products';

import {
  FinancialProductOffer,
  FinancialProductPreferenceRefusal,
} from '../../../api/types/onlineOfferTypes';

/**
 * An availability refusal expires once a later poll can describe the opened product again.
 * Revision conflicts instead remain until the rebased write settles them.
 */
export const hasRecoveredFromRefusal = (
  refusal: FinancialProductPreferenceRefusal | null,
  openedOffer: FinancialProductOffer | undefined
) =>
  match({refusal, offer: openedOffer})
    .with(
      {
        refusal: {kind: 'REFUSED'},
        offer: {availability: Pattern.union('AVAILABLE', 'UNAVAILABLE')},
      },
      ({refusal: refused, offer}) =>
        getFinancialProductOffer(refused.current, offer.productType)?.availability === 'UNAVAILABLE'
    )
    .otherwise(() => false);
